import { AxiosRequestConfig } from 'axios';
import { IFraud } from './types/api/main/get-fraud-action-list/get/code-200';
import { IDataBill } from './types/api/main/get-bill/get/code-200';

import { request } from './';

export const getBill = (config?: AxiosRequestConfig) => {
    return request<IDataBill>({
        url: '/bill/check',
        method: 'get',
        ...config
    });
};

export const getBillId = (bill_id: number, config?: AxiosRequestConfig) => {
    return request<IDataBill>({
        url: `/bill/${bill_id}`,
        method: 'get',
        ...config
    });
};

export const getBillChecked = (bill_id: number, config?: AxiosRequestConfig) => {
    return request<{result: string}>({
        url: `/bill/checked/${bill_id}`,
        method: 'post',
        ...config
    });
};

export const getFraudActionList = (config?: AxiosRequestConfig) => {
    return request<Array<IFraud>>({
        url: '/fraud_action/list',
        method: 'get',
        ...config
    });
};

export const addOperationFraud = (config?: AxiosRequestConfig) => {
    return request<{result: string}>({
        url: `/operation/fraud_add`,
        method: 'post',
        ...config
    });
};

export const deleteOperationFraud = (config?: AxiosRequestConfig) => {
    return request<{result: string}>({
        url: `/operation/fraud_delete`,
        method: 'post',
        ...config
    });
};

export const addBillFraud = (config?: AxiosRequestConfig) => {
    return request<{result: string}>({
        url: `/bill/fraud_add`,
        method: 'post',
        ...config
    });
};

export const deleteBillFraud = (config?: AxiosRequestConfig) => {
    return request<{bill_id: number}>({
        url: `/bill/fraud_delete`,
        method: 'post',
        ...config
    });
};
